import carbuyservice from '../api/clients/carBuyService'

export default {
  getAll: async function () {
    return await carbuyservice.get('/callcode')
  },
  getCustomerCallCodes: async function () {
    return await carbuyservice.get('/callcode/Customer')
  },
  getAllCodeTypes: async function () {
    return await carbuyservice.get('/callcode/category')
  },
  create: async function (data) {
    return await carbuyservice.post('/callcode', data, true)
  },
  update: async function (data) {
    return await carbuyservice.put('/callcode', data, true)
  }
}



// WEBPACK FOOTER //
// ./src/api/callcodes.js